  import Swal from "sweetalert2";
  export const handleDriverDelete = async (driverId , {fetchData, transfersData, setDeletingDriverId, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError}) => {
    try {
      // Check if driver has transfers
      const hasTransfers = transfersData.some(
        (transfer) =>
          transfer.assignedDriver && transfer.assignedDriver._id === driverId
      );

      if (hasTransfers) {
        await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "This driver has assigned transfers. Please reassign them first.",
          confirmButtonColor: "#1e3a8a",
        });
        return;
      }

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to recover this driver!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1e3a8a",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        setDeletingDriverId(driverId);
        await drivers.deleteDriver(driverId);
        await Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The driver has been deleted.",
          confirmButtonColor: "#1e3a8a",
        });
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting driver:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete driver. Please try again.",
        confirmButtonColor: "#1e3a8a",
      });
    } finally {
      setDeletingDriverId(null);
    }
  };